module.exports = __webpack_public_path__ + "static/media/logos_video.69582b4e.png";